import { useSelector } from "react-redux";

const useSetupDetails = () => useSelector((state) => state.SetupReducer);

export default useSetupDetails;
